import { LitElement, html } from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {likesStyles} from "@/components/likes/likes.styles.ts";

@customElement('sbk-likes')
export class SbkLikes extends LitElement {

  @property()
  amount = ''

  @property({attribute: 'like-label'})
  likeLabel = ''

  @property({attribute: 'unlike-label'})
  unlikeLabel = ''

  @property()
  page = ''

  @property()
  token = ''

  static get styles() {
    return likesStyles;
  }


  render() {
    const userLikes = this._getCookie('sbk_ch_likes') ?? '';
    if (userLikes.includes(this.page)) {
      return html`
        <div class="likes-container">
          <span>${this.amount}</span>
          <sbk-round-button @click=${this._onClick} variant="icon-only" size="medium" icon="heart-filled">${this.unlikeLabel}</sbk-round-button>
        </div>
    `;
    }
    return html`
      <div class="likes-container">
        <span>${this.amount}</span>
        <sbk-round-button @click=${this._onClick} variant="icon-only" size="medium" icon="heart">${this.likeLabel}</sbk-round-button>
      </div>
    `;
  }

  _onClick(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    fetch(`?id=${this.page}&type=3003&token=${this.token}`)
        .then((response) => {
          return response.text()
        })
        .then((data) => {
          this.amount = data;
        });
  }

  _getCookie(name: string) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
  }
}